export const pillCycleLength = 28;
